export const labelPresets: string[] = [
    "#HIRING",
    "#OPENFORWORK",
    "#FREELANCING",
    "#ONLEAVE",
]